import { ArrayQ } from "@pdfking/structs"

/**
 * Wraps a value in an array unless it already is one.
 *
 * @param value - A value or array of values
 * @returns The array unchanged, or a single-item array wrapping the value
 *
 * @example
 * ```ts
 * import { ToArray } from "@pdfking/tfunc"
 *
 * ToArray(1) // [1]
 * ToArray([1, 2, 3]) // [1, 2, 3]
 * ```
 */
export const ToArray = <T>(value: T | T[]): T[] => (ArrayQ(value) ? value : [value])
